import React, { useState, useEffect, useRef } from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { UserAuth } from "../context/AuthContext";
import { db } from "../firebase";
import { onSnapshot, doc, updateDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import axios from "axios";

const SavedMunis = () => {
  const [munis, setMunis] = useState([]);
  const { user } = UserAuth();
  const [liveStatus, setLiveStatus] = useState({});
  const [series, setSeries] = useState([]);
  const [liveStreams, setLiveStreams] = useState([]);
  const [liveMunis, setLiveMunis] = useState([]);
  const sliderRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    axios.get(process.env.REACT_APP_MUNI_JSON_URL).then((response) => {
      setSeries(response.data.series);
    });

    axios.get(process.env.REACT_APP_LIVE_STREAMS_JSON_URL).then((response) => {
      setLiveStreams(response.data);
    });
  }, []);

  useEffect(() => {
    const newLiveMunis = series.filter((muni) =>
      muni.episodes.some((episode) => {
        const episodeName = episode.content.videos[0].url
          .split("/")
          .slice(-3, -1)
          .join("/");
        return liveStreams.includes(episodeName);
      })
    );
    setLiveMunis(newLiveMunis);
  }, [series, liveStreams]);

  useEffect(() => {
    const checkAllEpisodes = () => {
      const newLiveStatus = series.reduce((acc, muni) => {
        const hasLiveEpisode = muni.episodes.some((episode) => {
          const episodeName = episode.content.videos[0].url
            .split("/")
            .slice(-3, -1)
            .join("/");
          return liveStreams.includes(episodeName);
        });
        acc[muni.id] = hasLiveEpisode;
        return acc;
      }, {});
      setLiveStatus(newLiveStatus);
    };

    checkAllEpisodes();
  }, [series, liveStreams]);

  const slideLeft = () => {
    const slider = document.getElementById("slider");
    if (slider) {
      slider.scrollLeft -= 500;
    }
  };

  const slideRight = () => {
    const slider = document.getElementById("slider");
    if (slider) {
      slider.scrollLeft += 500;
    }
  };

  useEffect(() => {
    if (user?.uid) {
      const unsubscribe = onSnapshot(doc(db, "users", user.uid), (doc) => {
        setMunis(doc.data()?.savedMunis || []);
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [user?.uid]);

  const muniRef = doc(db, "users", `${user?.uid}`);

  const deleteMuni = async (passedID) => {
    try {
      const result = munis.filter((muni) => muni.id !== passedID);
      await updateDoc(muniRef, {
        savedMunis: result,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (sliderRef.current) {
      setIsOverflowing(
        sliderRef.current.scrollWidth > sliderRef.current.clientWidth
      );
    }
  }, [series]);

  return (
    <>
      <div>
        <h2 className="text-white font-bold md:text-xl p-4">My favourites</h2>
        <div className="relative flex items-center group pl-2">
          {isOverflowing && (
            <MdChevronLeft
              onClick={slideLeft}
              className="bg-yellow-400 left-0 rounded-full absolute opacity-50 hover:opacity-100 cursor-pointer z-10 hidden group-hover:block"
              size={40}
            />
          )}
          <div
            id={"slider"}
            className="w-full h-full overflow-x-scroll whitespace-nowrap scroll-smooth scrollbar-hide"
          >
            {munis.map((muni, id) => (
              <div
                key={id}
                className="w-[160px] sm:w-[200px] md:w-[240px] lg:w-[280px] inline-block cursor-pointer relative p-2"
              >
                <Link to={`/fc/${muni.id}`}>
                  <img
                    className="w-full h-auto block rounded"
                    src={muni.img}
                    alt={muni.title}
                  />
                  <div className="absolute top-0 left-0 w-full h-full hover:bg-black/80 opacity-0 hover:opacity-100 text-white">
                    <p className="white-space-normal text-xs md:text-sm font-bold flex justify-center items-center h-full text-center">
                      <span className="text-white justify-center text-wrap items-center text-center">
                        {muni.title}
                      </span>
                    </p>
                  </div>
                  <p className="white-space-normal text-xs md:text-sm font-bold flex justify-center items-center h-full text-center text-wrap">
                    <span className="text-white justify-center items-center text-center">
                      {muni.title}
                    </span>
                  </p>
                  {liveStatus[muni.id] && (
                    <p className="absolute top-4 right-4 bg-red-600 text-white text-xs px-2 py-1 rounded">
                      LIVE
                    </p>
                  )}
                </Link>
                <p
                  onClick={() => deleteMuni(muni.id)}
                  className="absolute text-black top-4 left-4"
                >
                  <AiOutlineClose />
                </p>
              </div>
            ))}
          </div>
          {isOverflowing && (
            <MdChevronRight
              onClick={slideRight}
              className="bg-yellow-400 right-0 rounded-full absolute opacity-50 hover:opacity-100 cursor-pointer z-10 hidden group-hover:block"
              size={40}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SavedMunis;
